// Frontend JavaScript
import '../../css/app/index.scss';
import './pricing-manager.js'; // Load pricing manager globally
import { initTracking } from './statsigEvents';

// Initialize Statsig variants and event tracking
initTracking();

console.log('Frontend loaded');
